"use strict";

var bignum = require("./bignum");

function encodeNumberAsBase10String(n, isWrapped) {
  return bignum(n, "string", isWrapped);
}

module.exports = encodeNumberAsBase10String;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/encode-number-as-base10-string.js
// module id = 496
// module chunks = 146